import React, { createContext, useContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";

// Create a Context
const SnackbarContext = createContext();

// Slide Transition Component
function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

// SnackbarProvider Component
export function SnackbarProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success"); // 'success', 'error', 'info', or 'warning'

  // Function to show the snackbar
  const showSnackbar = (newMessage, newSeverity = "success") => {
    setMessage(newMessage);
    setSeverity(newSeverity);
    setOpen(true);
  };

  // Function to close the snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        TransitionComponent={SlideTransition}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          borderLeft: "5px solid",
          borderColor:
            severity === "success"
              ? "success.main"
              : severity === "error"
              ? "error.main"
              : severity === "info"
              ? "info.main"
              : "warning.main",
        }}
      >
        <Alert
          onClose={handleClose}
          severity={severity}
          //variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

// Custom Hook to Use Snackbar
export const useSnackbar = () => useContext(SnackbarContext);
